import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";

export const FiberAlarm = ({ t }) => (
  <section id="alarm" data-testid="section-alarm" className="relative py-32 md:py-48 border-b border-[#272A2E] overflow-hidden">
    <img src="/images/night_drone.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-[0.12] grayscale pointer-events-none" />
    <div className="relative max-w-[1600px] mx-auto px-6 md:px-10">
      <Reveal><SectionHead index={t.index} title={t.title} lead={t.lead} /></Reveal>
      <div className="grid md:grid-cols-2 gap-px bg-[#272A2E] border border-[#272A2E]">
        {t.points.map((p, i) => (
          <Reveal key={p.t} delay={0.1 + i * 0.08} className="bg-[#050505]/95">
            <div data-testid={`alarm-point-${i}`} className="p-8 md:p-12 h-full hover:bg-[#121417] transition-colors duration-500">
              <div className="flex items-baseline gap-4">
                <span className="text-xs font-mono text-[#FF2A00]">0{i + 1}</span>
                <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-white">{p.t}</h3>
              </div>
              <p className="mt-5 text-sm font-mono tracking-tight text-[#8A8F98] leading-relaxed pl-8">{p.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
